'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
var getLoginCallbackParams = function getLoginCallbackParams() {
    var state = window.localStorage.getItem('auth_state');
    var origin = window.localStorage.getItem('auth_origin');
    window.localStorage.removeItem('auth_state');
    window.localStorage.removeItem('auth_origin');

    return {
        state: state,
        origin: origin
    };
};

var verifyLoginCallback = function verifyLoginCallback(_ref) {
    var location = _ref.location;

    var _getLoginCallbackPara = getLoginCallbackParams(),
        origin = _getLoginCallbackPara.origin,
        state = _getLoginCallbackPara.state;

    if (state !== location.query.state) {
        return _promise2.default.reject('invalid auth state');
    }

    return _promise2.default.resolve({ origin: origin });
};

exports.default = verifyLoginCallback;
//# sourceMappingURL=verifyLoginCallback.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-spid/lib/cjs/verifyLoginCallback.js
 ** module id = 297
 ** module chunks = 0
 **/